import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";
import bgImg from "../../assets/images/backgroundImage.png";
import { useAppSelector } from "tools/store";
import { getTheme } from "features/apps/global_slice";

const BackgroundView: React.FC<BoxProps> = (props) => {
  const isLightTheme = useAppSelector(getTheme) === "light";
  if (isLightTheme) {
    return (
      <Box
        // backgroundImage={`url(${bgImg})`}
        // backgroundSize="cover"
        // backgroundPosition="center"
        // h="100vh"
        h={window.innerHeight}
        w="100%"
        bgColor={"secondary.950"}
        {...props}
      />
    );
  }
  return (
    <Box
      backgroundImage={`url(${bgImg})`}
      backgroundSize="cover"
      backgroundPosition="center"
      // h="100vh"
      h={window.innerHeight}
      w="100%"
      bgColor={"secondary.950"}
      {...props}
    />
  );
};

export default BackgroundView;
